<template>
  <div class="componentName">
    <div class="ModernList2">
      <div class="ModernList2__heading">
        <span class="ModernList2__heading--title">{{ items.category_name_str }}</span>
      </div>
    </div>
    <ul class="item">
      <li class="item__list"
        v-for="(item, index) in limitedRanking"
        :key="index"
        :class="crown(index)"
      >
        <a :href="item.url" class="item__list__link">
          <span class="image-wrap" >
            <img v-if="!!item.pack_image"
              :src="item.pack_image"
              @load="onImgLoad"
              class="item__list__link__image"
            >
          </span>
          <div class="item__list__link__detail" :class="noimageClass(item)">
            <p class="item__list__link__detail__title">{{item.items_name}}</p>
            <p class="item__list__link__detail__description">{{item.description}}</p>
            <ul class="item__list__link__detail__tag">
              <li :class="`disp-type${item.disp_type}`" v-if="item.price !== 0"></li>
              <li class="item__list__link__detail__tag__list" :class="`tag-bg-color${item.price}`" v-if="item.price === 0">お試し</li>
              <li class="item__list__link__detail__tag__list" :class="`tag-bg-color${item.disp_type}`" v-else-if="item.disp_type === 1 && item.price > 0">すぐ見れる!</li>
              <li class="item__list__link__detail__tag__list" :class="`tag-bg-color${item.disp_type}`" v-else-if="item.disp_type === 3">今なら1時間で!</li>
            </ul>
            <div class="item__list__link__detail__evaluatewrap">
              <div class="item__list__link__detail__evaluatewrap__inner">
                <p class="item__list__link__detail__price">
                  ¥{{item.price | priceFormat}}
                  <span class="item__list__link__detail__tax">（税込）</span>
                </p>
                <p class="item__list__link__detail__stars" v-if="showStars">
                  <evaluate-stars :stars="item.stars" />
                </p>
              </div>
            </div>
          </div>
        </a>
      </li>
    </ul>
    <div class="ModernList2__link">
      <a :href="/category/ + `${categoryName}`">もっと見る</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modern-list2',
  data() {
    return {
      showStars: false
    }
  },
  props: {
    items: {
      type: Object,
      default: () => ({})
    },
    rankLabelShow: {
      type: Boolean,
      default() { return true }
    }
  },
  computed: {
    arrayItems() {
      if (this.items == null) {
        return []
      }
      return Object.entries(this.items)
    },
    limitedRanking() {
      let ranking = []
      for ( var i = 0 ; i < 3; i++) {
        ranking.push(this.arrayItems[i][1])
      }
      return ranking
    },
    categoryName() {
      return this.items.category_name_url
    },
  },
  methods: {
    srcCreater(item) {
      if (item.planning_id === '') return item.pack_image;
      return `/static/img/top/videoletter_custom_${item.planning_id}.jpg`;
    },
    noimageClass(item) {
      if (!item.pack_image) return 'noimg';
    },
    onImgLoad() {
      this.showStars = true
    },
    crown(index) {
      if (this.rankLabelShow === true && index < 3) {
        return `rank${index+1}`
      }
      return ''
    }
  },
  filters: {
    priceFormat(val) {
      return val.toLocaleString()
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../sass/variables/index';
@import '../../../sass/functions/breakpoint.scss';

.componentName {
  background: $white;
}

.ModernList2 {
  padding: 20px 12px 2px 12px;
  &__heading {
    &--title {
      font-size: 18px;
      line-height: 18px;
      font-weight: bold;
      color: $brand-0;
    }
  }

  &__link {
    text-align: right;
    padding: 16px 0;
    background: $white;
    & > a {
      color: #E4007F;
      text-decoration-line: underline;
      font-size: 14px;
      margin-right: 14px;
    }
  }
}

.item {
  background: $white;
  margin: 0;
  padding: 0;
  list-style: none;
  &__list {
    @media screen and (min-width: 320px) {
      height: 130px;
    }
    @media screen and (min-width: 375px) {
      height: 152px;
    }
    @media screen and (min-width: 768px) {
      height: 200px;
    }
    position: relative;
    &.rank1,
    &.rank2,
    &.rank3 {
      &::after {
        content: '';
        width: 40px;
        height: 32px;
        display: block;
        position: absolute;
        top: -5px;
        left: 5px;
        background-size: 100%;
      }
    }
    &.rank1 {
      &::after {
        background: url('/static/img/top/crown_01.svg') no-repeat center center;
      }
    }

    &.rank2 {
      &::after {
        background: url('/static/img/top/crown_02.svg') no-repeat center center;
      }
    }

    &.rank3 {
      &::after {
        background: url('/static/img/top/crown_03.svg') no-repeat center center;
      }
    }
    &__link {
      border: 1px solid  $gray-10;
      border-radius: 5px;
      overflow: hidden;
      position: relative;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      margin: 12px 12px 12px;
      text-decoration: none;
      height: 100%;
      @media screen and (min-width: 375px) {
        margin: 12px 12px 0;
      }

      .image-wrap {
        display: block;
        @media screen and (min-width: 320px) {
          height: 100%;
        }
        position: relative;
      }
      &__image {
        display: block;
        object-fit: cover;
        height: 130px;
        width: 130px;
        @media screen and (min-width: 375px) {
          height: 152px;
          width: 152px;
        }
        @media screen and (min-width: 768px) {
          height: 200px;
          width: 200px;
        }
      }
      &__detail {
        width: calc(100% - 116px);
        position: relative;
        font-size: 11px;
        padding: 8px 10px 0px 10px;
        @media screen and (min-width: 375px) {
          font-size: 12px;
          position: static;
          width: calc(100% - 150px);
          padding: 11px 14px 10px 14px;
        }
        @media screen and (min-width: 738px) {
          padding: 18px 14px 10px 14px;
        }
        &__title {
          line-height: 1.23;
          margin-top: 0;
          min-height: 26px;
          @media screen and (min-width: 320px) {
            min-height: 22px;
          }
          font-weight: bold;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          /* autoprefixer: off */
          -webkit-box-orient: vertical;
          /* autoprefixer: on */
          overflow: hidden;
          @media screen and (min-width: 768px) {
            font-size: 16px;
          }
        }
        &__description {
          line-height: 1.25;
          margin-top: 7px;
          @media screen and (min-width: 320px) {
            margin-top: 6px;
          }
          @media screen and (min-width: 375px) {
            margin-top: 7px;
          }
          color: $brand-0;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          /* autoprefixer: off */
          -webkit-box-orient: vertical;
          /* autoprefixer: on */
          overflow: hidden;
          @media screen and (min-width: 768px) {
            font-size: 14px;
          }
        }
        &__tag {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          margin: 12px 0 5px;
          @media screen and (min-width: 320px) {
            margin: 7px 0 0px;
          }
          @media screen and (min-width: 375px) {
            margin: 12px 0 0px;
          }
          padding: 0;
          list-style: none;
          &__list {
            line-height: 17px;
            margin: 0 4px 2px 0;
            padding: 1px 8px;
            font-size: 10px;
            transform: scale(0.9);
            font-weight: bold;
            color: white;
            background: #F2994A;
            border-radius: 10px;
            text-align: center;
            &:last-child {
              margin-right: 0;
            }
            @include breakpoint(mobileonly) {
              min-width: auto;
            }
          }
        }
        &__evaluatewrap {
          width: 100%;
          &__inner {
            width: 100%;
          }
        }
        &__stars {
          display: inline-block;
          vertical-align: bottom;
          line-height: 1;
          @media screen and (min-width: 320px) {
            vertical-align: initial;
            margin-top: 3px;
          }
          @media screen and (min-width: 375px) {
            margin-top: 4px;
          }

          /deep/ .evaluate-stars-base {
            font-size: 11px;
            line-height: 1;
            @media screen and (min-width: 768px) {
              font-size: 14px;
            }
          }
        }
        &__price {
          font-size: 12px;
          font-weight: bold;
          color: $brand-2;
          line-height: 1;
          span {
            font-size: 10px;
          }
          @media screen and (min-width: 375px) {
            margin-top: 3px;
            right: 16px;
          }
          @media screen and (min-width: 768px) {
            font-size: 16px;
            right: 16px;
            span {
              font-size: 12px;
            }
          }
        }

        &__tax {
          color: #676767;
          font-weight: normal;
          font-size: 10px;
          display: inline-block;
          transform: translate(-11px, 1px) scale(0.8);
          @media screen and (min-width: 320px) {
            vertical-align: initial;
          }
          @media screen and (min-width: 768px) {
            transform: translate(-15px, 1px) scale(0.8);
          }
        }
      }
    }
  }
}

.disp-type {
  &1 {
    width: 15px;
    height: 16px;
    margin: 0 4px 4px 0;
    background: url('/static/img/top/ic_genre_text.svg');
    background-size: cover;
  }
  &2 {
    width: 15px;
    height: 16px;
    margin: 0 4px 4px 0;
    background: url('/static/img/top/ic_genre_order.svg');
    background-size: cover;
  }
  &3 {
    width: 15px;
    height: 16px;
    margin: 0 4px 4px 0;
    background: url('/static/img/top/ic_genre_movie.svg');
    background-size: cover;
  }
}

.tag-bg-color {
  &0 {
    background: #2D9CDB;
  }

  &1 {
    background: #ED1E79;
  }

  &2 {
    background: #F2994A;
  }
}

.noimg {
  width: 100%;
  min-height: 109px;
}
</style>




// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/ModernList2.vue